import React from 'react';
import { TextField, IconButton, Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const WinnerPostionsComponent = ({ index, winnerData, handleChange,handleRemove }) => {
    return (
        <Box display="flex" alignItems="center" gap={2} my={1}>
            <TextField
                label="Position"
                type="number"
                variant="outlined"
                value={winnerData.position}
                onChange={(e) => handleChange(index, 'position', e.target.value)}
            />
            <TextField
                label="Total Views"
                type="number"
                variant="outlined"
                value={winnerData.totalViews}
                onChange={(e) => handleChange(index, 'totalViews', e.target.value)}
            />
            <TextField
                label="Total Comments"
                type="number"
                variant="outlined"
                value={winnerData.totalComments}
                onChange={(e) => handleChange(index, 'totalComments', e.target.value)}
            />
            <TextField
                label="Total Likes"
                type="number"
                variant="outlined"
                value={winnerData.totalLikes}
                onChange={(e) => handleChange(index, 'totalLikes', e.target.value)}
            />
            <TextField
                label="Price"
                type="number"
                variant="outlined"
                value={winnerData.prize}
                onChange={(e) => handleChange(index, 'prize', e.target.value)}
            />

<IconButton color="error" onClick={() => handleRemove(index)} aria-label="delete">
        <DeleteIcon />
      </IconButton>
        </Box>
    );
};
